import React from "react";
import { Col, Row, Form, Input, Label, FormGroup } from "reactstrap";
export default function PreviewComp(props) {
  const { formValues = [], requiredDoc = [] } = props;
  return (
    <div>
      <Form>
        <Row>
          {formValues.map((f, order) => (
            <>
              {["text", "number", "textarea", "date", "time"].includes(
                f.type
              ) && (
                <Col md="4">
                  <FormGroup>
                    <Label>
                      {" "}
                      {order + 1}. {f.label}
                    </Label>
                    <Input type={f.type} placeholder={f.placeholder}></Input>
                  </FormGroup>
                </Col>
              )}
              {f.type === "select" && (
                <Col md="4">
                  <Label>
                    {order + 1}. {f.label}
                  </Label>{" "}
                  <FormGroup>
                    {" "}
                    <Input type={f.type} placeholder={f.placeholder}>
                      {" "}
                      {f.options.map((o) => (
                        <option value={o.value}>{o.value}</option>
                      ))}{" "}
                    </Input>
                  </FormGroup>{" "}
                </Col>
              )}
              {f.type === "radio" && (
                <>
                  <FormGroup>
                    <Label>
                      {order + 1}.{f.label}
                    </Label>
                    {f.options.map((o, index) => (
                      <>
                        <Col md="4">
                          <Label check>
                            <Input type="radio" id="" name={f.uniqueId} />
                            {o.value}
                          </Label>
                        </Col>{" "}
                      </>
                    ))}
                  </FormGroup>
                </>
              )}

              {f.type === "checkbox" && (
                <>
                  <Col md="4">
                    <FormGroup check>
                      <Label>
                        {order + 1}.{f.label}
                      </Label>
                      {f.options.map((o, index) => (
                        <>
                          <Col md="12">
                            <Label check>
                              <Input type="checkbox" name={f.uniqueId} />{" "}
                              {o.value} &nbsp;{" "}
                            </Label>
                          </Col>
                        </>
                      ))}{" "}
                    </FormGroup>{" "}
                  </Col>
                </>
              )}
            </>
          ))}
        </Row>
        <Row>
          {requiredDoc.map((i, index) => (
            <>
              <Col md="4">
                <Label>
                  {index + 1}. {i.documentName}
                  {i.isMandatory ? "*" : ""}{" "}
                </Label>
                <div class="file-upload-btn-wrapper">
                  <button class="file-upload-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.945"
                      height="19.945"
                      viewBox="0 0 19.945 19.945"
                    >
                      <g
                        id="Icon_feather-upload"
                        data-name="Icon feather-upload"
                        transform="translate(1 1)"
                      >
                        <path
                          id="Path_36"
                          data-name="Path 36"
                          d="M22.445,22.5v3.988a1.994,1.994,0,0,1-1.994,1.994H6.494A1.994,1.994,0,0,1,4.5,26.488V22.5"
                          transform="translate(-4.5 -10.537)"
                          fill="none"
                          stroke="#1b3e6f"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                        <path
                          id="Path_37"
                          data-name="Path 37"
                          d="M20.469,9.485,15.485,4.5,10.5,9.485"
                          transform="translate(-6.512 -4.5)"
                          fill="none"
                          stroke="#1b3e6f"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                        <path
                          id="Path_38"
                          data-name="Path 38"
                          d="M18,4.5V16.463"
                          transform="translate(-9.028 -4.5)"
                          fill="none"
                          stroke="#1b3e6f"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                      </g>
                    </svg>
                    Upload a file
                  </button>
                  <Input type="file" name="myfile" />
                </div>
              </Col>
            </>
          ))}
        </Row>
      </Form>
    </div>
  );
}
